import { Box, Divider, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import { Outlet, useMatch, useNavigate } from "react-router-dom";

import { Spacing } from "../types/enum";

const MaintenanceLayout: React.FC = () => {
  const navigate = useNavigate();
  const match = useMatch("/maintenance/:pageName");
  const pageName = match?.params.pageName ?? "tasks";

  const onChange = (_: React.ChangeEvent<unknown>, nextPageName: string) => {
    navigate(`/maintenance/${nextPageName}`);
  };

  return (
    <>
      <Box mb={Spacing.m}>
        <Typography variant="h3" color="textPrimary">
          Maintenance
        </Typography>
      </Box>

      <Box>
        <Tabs
          scrollButtons="auto"
          variant="scrollable"
          textColor="secondary"
          value={pageName}
          onChange={onChange}
        >
          <Tab label="Maintenance Tasks" value="tasks" />
          <Tab label="Daily Hooks" value="hooks" />
        </Tabs>
      </Box>

      <Divider />

      <Box mt={Spacing.m}>
        <Outlet />
      </Box>
    </>
  );
};

export default MaintenanceLayout;
